import { ObjectShim } from '@packages/helpers/core/shims/object-shim';

export const sortBlocks = blocks => ObjectShim.entries(blocks).sort(([a], [b]) => blocks[a].weight - blocks[b].weight);
